import { render, staticRenderFns } from "./HuiZiChanFuZhai.vue?vue&type=template&id=def6e01c&scoped=true"
import script from "./HuiZiChanFuZhai.vue?vue&type=script&lang=js"
export * from "./HuiZiChanFuZhai.vue?vue&type=script&lang=js"
import style0 from "./HuiZiChanFuZhai.vue?vue&type=style&index=0&id=def6e01c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def6e01c",
  null
  
)

export default component.exports